import { useState, useEffect, useCallback, useRef } from 'react';

interface UseTimerProps {
  initialActive?: boolean;
  stopAt?: number;
}

const useTimer = ({ initialActive, stopAt }: UseTimerProps) => {
  const [ passed, setPassed ] = useState(0);
  const [ isActive, setIsActive ] = useState(initialActive || false);
  const interval = useRef<null | number>(null);

  const toggle = useCallback((active?: boolean) => {
    setIsActive((prev) => (active === undefined ? !prev : active));
  }, [ setIsActive ]);

  const reset = useCallback((active?: boolean) => {
    setPassed(0);
    toggle(active);
  }, [ setPassed, toggle ]);

  useEffect(() => {
    if (stopAt && isActive && passed >= stopAt) toggle(false);
  }, [ isActive, passed, stopAt, toggle ]);
  const remaining = stopAt ? stopAt - passed : -1;

  useEffect(() => {
    const clear = () => {
      if (interval.current) window.clearInterval(interval.current);
    };
    if (isActive) {
      interval.current = window.setInterval(() => {
        setPassed((prev) => prev + 1);
      }, 1000);
    } else {
      clear();
    }
    return clear;
  }, [ isActive, setPassed ]);

  return {
    passed,
    remaining,
    isActive,
    toggle,
    reset,
  };
};

export default useTimer;
